import { render, staticRenderFns } from "./BaseRouterLinkNavigation.vue?vue&type=template&id=1aa06097&scoped=true&"
import script from "./BaseRouterLinkNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseRouterLinkNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BaseRouterLinkNavigation.vue?vue&type=style&index=0&id=1aa06097&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa06097",
  null
  
)

export default component.exports